import { useEffect, useRef } from "react";

const BetaBanner = () => {
  const bannerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const updateHeight = () => {
      if (!bannerRef.current) return;
      const height = bannerRef.current.offsetHeight;
      document.documentElement.style.setProperty("--beta-banner-height", `${height}px`);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  return (
    <div
      ref={bannerRef}
      className="fixed top-0 left-0 right-0 z-[100] bg-primary/90 text-primary-foreground text-center text-xs font-medium backdrop-blur-sm border-b border-primary/20 flex items-center justify-center px-4 py-2"
    >
      <p>
        This website is still in <span className="font-semibold">BETA</span> - We're actively improving the experience
      </p>
    </div>
  );
};

export default BetaBanner;

